import type { MetricConfig } from '../../types/config';
import type { KpiOption } from '../../PlanDetail/MetricPage/config/kpiCatalog';

/**
 * Backend group key for report KPIs. Symmetric with `PROMO_GROUP_KEYS` /
 * `SPEND_GROUP_KEYS` in `metricAdapter` (which feed the editable grid).
 */
export const KPI_GROUP_KEYS = new Set<string>(['kpi_metrics']);

/**
 * Builds the MetricPage KPI catalog directly from `metrics[]` (the entries whose
 * `group` is a KPI group), independent of `metric_views`. Ordered by the
 * metric's `order`. `sortable` defaults to `true` because metric definitions do
 * not carry a per-metric sort flag. Tolerant: returns `[]` when no KPI metrics
 * are present (the report toolbar simply offers no KPIs rather than blocking).
 */
export function adaptKpiCatalog(metrics: MetricConfig[]): KpiOption[] {
    return metrics
        .filter((m) => KPI_GROUP_KEYS.has(m.group))
        .sort((a, b) => a.order - b.order)
        .map((m) => ({ key: m.key, name: m.display_name, sortable: true }));
}
